<app-loader [size]="30" [opacity]="'0.7'" [center]="true" *ngIf="alaCarteMenuFile === null"></app-loader>

<ng-container *ngIf="alaCarteMenuFile?.value">
  <a [href]="alaCarteMenuFile?.value|apiUrl" target="_blank" class="btn btn-bordered">{{ text | translate }}</a>
</ng-container>
<ng-container *ngIf="alaCarteMenuFile !== null && !alaCarteMenuFile?.value">
  <span class="small">{{ 'menu_is_currently_unavailable'|translate }}</span>
</ng-container>
